import React from 'react'

import iconsList from './iconsList'
import { type IconProps } from './Icon.models'
import styles from './_icons.module.scss'

const Icon = ({
  icon,
  className = '',
  iconSize = '20px',
  color = 'purple',
  qaTestId = 'icon',
}: IconProps): React.JSX.Element => {
  const iconInlineStyles = {
    '--svg-height': iconSize,
    '--svg-width': iconSize,
    '--svg-color': `var(--${color})`,
  } as React.CSSProperties

  return (
    <span
      className={`${icon} ${styles.iconStyles} ${className}`}
      style={iconInlineStyles}
      data-testid={`icon-${icon}`}
      qa-test-id={qaTestId}
    >
      {iconsList[icon]}
    </span>
  )
}

export default Icon
